module.exports = __webpack_public_path__ + "static/img/logo.75c517a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/study/logo.png
// module id = B57z
// module chunks = 0